import { render, staticRenderFns } from "./CardCost.vue?vue&type=template&id=a33d4f04&"
import script from "./CardCost.vue?vue&type=script&lang=ts&"
export * from "./CardCost.vue?vue&type=script&lang=ts&"
import style0 from "./CardCost.vue?vue&type=style&index=0&id=a33d4f04&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports